module.exports = __webpack_public_path__ + "img/img-106.be2c0682.png";